function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.3334 0C4.81087 0 0.333374 4.4775 0.333374 10C0.333374 15.5225 4.81087 20 10.3334 20C15.8559 20 20.3334 15.5225 20.3334 10C20.3334 4.4775 15.8559 0 10.3334 0ZM14.0342 14.0767C12.2825 14.1967 8.38087 14.1967 6.63171 14.0767C4.73504 13.9467 4.51421 13.0183 4.50004 10C4.51421 6.97583 4.73754 6.05333 6.63171 5.92333C8.38087 5.80333 12.2834 5.80333 14.0342 5.92333C15.9317 6.05333 16.1517 6.98167 16.1667 10C16.1517 13.0242 15.9292 13.9467 14.0342 14.0767ZM12.7642 9.99667L8.66671 8.04833V11.9517L12.7642 9.99667Z",
  fill: "white"
});

function SvgYoutubeWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeWhite);
export default __webpack_public_path__ + "static/media/youtube-white.2523072b.svg";
export { ForwardRef as ReactComponent };